import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const Age = lazyWithPreload(() => import('./Age'))
export const AgeAsIntro = lazyWithPreload(() => import('./AgeAsIntro'))
export const LikeChatAge = lazyWithPreload(() => import('./LikeChatAge'))
export const AgeAsIntroProvider = lazyWithPreload(
  () => import('./AgeAsIntroProvider'),
)
export const IntroSaleAgeAsIntro = lazyWithPreload(
  () => import('./IntroSaleAgeAsIntro'),
)
export const AgeWithImages = lazyWithPreload(() => import('./AgeWithImages'))
export const AgeWithImages2 = lazyWithPreload(() => import('./AgeWithImages2'))
export const AgeForIntroPlan = lazyWithPreload(
  () => import('./AgeForIntroPlan'),
)
export const AgeAsIntroWithImages = lazyWithPreload(
  () => import('./AgeAsIntroWithImages'),
)
